
import { Field, FieldLevelValidationInfo, ValidationMessageType } from ".../../../types/field";
import { UseFormGetValues } from "react-hook-form";
import { GetRequest } from "../../../../utils/api";
import { assignmentApis} from "../../../../utils/ApiURLs";


const stateHolidaysApi: string = assignmentApis.stateHolidaysApi;

export const isTheGivenDateIsAHoliday = async (input: string): Promise<boolean> => {
  if(input === undefined || input === null || input === ""){
    return false;
  }
  let endpoint: string = stateHolidaysApi;
  endpoint = endpoint.replace("{input}", input);

  return GetRequest(endpoint).then((response) => {
      return response.records && response.records.length > 0;
    })
    .catch((error) => {
      // Request failed, handle the error
      console.error(error);
      return false;
    });
};

export const holidayDateVerificationForFormField = (getValues: UseFormGetValues<any>, field: Field): Promise<FieldLevelValidationInfo|undefined> => {
   return isTheGivenDateIsAHoliday(getValues()[field.field])
   .then((result) => {

    if(result){
      return {
        field: field.field,
        type: "WARNING" as ValidationMessageType,
        message: "It is a public holiday."
      };
    }
    return undefined;
  })
  .catch((error) => {
    console.error('Error occurred:', error);
    return undefined;
  });
}


